module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8da171d7703a2e5c191ac63df1f855db.png";